import {
  ChangeDetectionStrategy,
  Component,
  computed,
  Signal,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { ImageComponent, SliderComponent, SliderSlideDirective } from '@libs/common/components';
import { IconComponent } from '@libs/components/icons';
import { KeyFigureCardSliderContentModel } from '@libs/cms/models';
import {
  ContentLinkDirective,
  EqualHeightGroupDirective,
  EqualHeightItemDirective,
  HtmlDataLinkDirective,
} from '@libs/shared/ui';
import { HeadlinesComponent } from '../../items';
import { ContentBaseComponent } from '../content-base.component';

@Component({
  selector: 'ui-key-figure-card-slider',
  templateUrl: './key-figure-card-slider.component.html',
  styleUrls: [
    './key-figure-card-slider.component.scss',
    './key-figure-card-slider.component.lekkerland-2026.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImageComponent,
    IconComponent,
    HeadlinesComponent,
    SliderComponent,
    SliderSlideDirective,
    ContentLinkDirective,
    EqualHeightGroupDirective,
    EqualHeightItemDirective,
    HtmlDataLinkDirective,
    MatButton,
  ],
})
export class KeyFigureCardSliderComponent extends ContentBaseComponent<KeyFigureCardSliderContentModel> {
  public readonly hasAnyButton: Signal<boolean> = computed(() =>
    this.data().cards.some(card => !!card.button?.link?.label),
  );
}
